export default __webpack_public_path__ + "static/media/uploader-roche-problem-2.6aa436fe.png";